/* eslint-disable max-len */
import React, { Fragment } from 'react'
import TableBody from './TableBody'
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import { useState,useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { selectAllDeviceRows } from '../../../../redux/MultiselectRowsConditionally';
import { useSelector ,useDispatch} from 'react-redux';

const ManageDeviceTable=({pageNumber,List,handleDelete,setConfirmationState,setTextAreaMsg,setSelectedRow,loading,isPatient,setIsAnyFieldFilled,setLoading})=>{
    const [searchParams,setSearchParams]=useSearchParams()
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const selectedRows=useSelector((state)=>state?.MultiSelectSliceConditionally?.selectedRows?.topCheckBox)
    const urlParams = new URLSearchParams(window.location.search);
    const dispatch=useDispatch()
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });
    const handleAllRowsSelect=(event)=>{
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        const paramstoPass=[event.target.checked,pageNumber.toString(),List.data]
        dispatch(selectAllDeviceRows(paramstoPass))
    }

    return(
        <div>
            <div className={`${isPatient!==undefined?(List?.total_count>=15?'2xl:h-[calc(100vh-524px)]':'2xl:h-[calc(100vh-490px)]'):'2xl:h-[calc(100vh-215px)]'} ${isPatient!==undefined?(List?.total_count>=15?'xl:h-[calc(100vh-534px)]':'xl:h-[calc(100vh-500px)]'):'xl:h-[calc(100vh-225px)]'} ${isPatient!==undefined?(List?.total_count>=15?'lg:h-[calc(100vh-590px)]':'lg:h-[calc(100vh-557px)]'):'lg:h-[calc(100vh-227px)]'} ${isPatient!==undefined?(List?.total_count>=15?'h-[calc(100vh-518px)]':'h-[calc(100vh-473px)]'):'h-[calc(100vh-227px)]'} pagination_bottom3 overflow-auto scrollbar_purple pb-2.5`}>
                <table aria-label="Outside Table" className="w-full table-auto">
                    <thead>
                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-0 left-0 z-[1]">
                            <th className="px-[18px] py-2 rounded-tl-sm rounded-bl-sm">
                                <div className="relative checkbox custom-checkBoxBlue1">
                                    <input type="checkbox" id={isPatient===undefined?pageNumber:'select_all1'} data-testid="checkbox" checked={selectedRows?.find(item=>item.page_number===pageNumber.toString())?.isChecked?true:false} onChange={handleAllRowsSelect}/>
                                    <label htmlFor={isPatient===undefined?pageNumber:'select_all1'} className="text-sm font-normal text-[#031624] w-full cursor-pointer"></label>
                                </div>
                            </th>
                            <th id="id" className="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">ID </span>
                            </th>
                            <th id="status" className="px-[18px] py-2 xl:min-w-[160px] min-w-[180px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Status</span>
                            </th>
                            {isPatient===undefined?<th id="reading_type" className="px-[18px] py-2 min-w-[300px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Reading Type</span>
                            </th>:<th className="px-[18px] py-2 min-w-[140px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Serial Number
                                </span>
                            </th>}
                            <th id="manufacturer" className="px-[18px] py-2 min-w-[120px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Manufacturer</span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[100px]">
                                <span className="flex items-center text-sm font-normal text-[#000000]">Model 
                                </span>
                            </th>
                            {isPatient===undefined?<th className="px-[18px] py-2 min-w-[140px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Serial Number
                                </span>
                            </th>:<th id="reading_type" className="px-[18px] py-2 min-w-[270px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Reading Type</span>
                            </th>}
                            {isPatient===undefined&&<th className="px-[18px] py-2 min-w-[100px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Patient ID
                                </span>
                            </th>}
                            {isPatient===undefined&&<th className="px-[18px] py-2 min-w-[195px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Assigned
                                </span>
                            </th>}
                            <th className="px-[18px] py-2 min-w-[140px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Purchase Date
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[150px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Service Provider
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[100px]">
                                <span className="flex items-center text-start justify-start text-sm font-normal text-[#000000]">Service Period
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[151px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Service Activation 
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[100px]">
                                <span className="flex items-center text-start justify-start text-sm font-normal text-[#000000]">Warranty Period
                                </span>
                            </th>
                            {isPatient===undefined&&<th className="px-[18px] py-2 min-w-[200px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Initial Reading
                                </span>
                            </th>}
                            <th className="px-[18px] py-2 min-w-[220px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Description
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[200px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Created
                                </span>
                            </th>
                            {isPatient===undefined&&<th className="px-[18px] py-2 rounded-tr-[2px] rounded-br-[2px] sticky top-0 right-[-1px] bg-[#EDD7E1] min-w-[70px]">
                                <span className="flex items-center justify-center text-sm font-normal text-[#000000]">Actions
                                </span>
                            </th>}
                        </tr>
                    </thead>
                    <tbody>
                        {List?.data?.map((item,index)=>(
                            <Fragment key={item._id}>
                                <TableBody
                                    tableData={item}
                                    List={List}
                                    indexNum={index}
                                    isPatient={isPatient}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List?.data?.length}
                                    setConfirmationState={setConfirmationState}
                                    setTextAreaMsg={setTextAreaMsg}
                                    setSelectedRow={setSelectedRow}
                                    handleDelete={handleDelete}
                                    loading={loading}
                                    setLoading={setLoading}
                                    setIsAnyFieldFilled={setIsAnyFieldFilled}
                                />
                            </Fragment>
                        ))}
                        
        
                    </tbody>
                    
                </table>

            </div>
        </div>
    )
}

export default ManageDeviceTable